import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/Tabs';
import Icon from '@/components/AppIcon';
import { PageLayout } from '@/components/ui/PageLayout';
import { UserCog } from 'lucide-react';
import CategoriesTab from './components/CategoriesTab';
import ReviewSettingsTab from './components/ReviewSettingsTab';

const TeamRoleManagementSettings: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>('categories');

  return (
    <PageLayout
      title={t('settings.teamRoleManagement.title')}
      description={t('settings.teamRoleManagement.description')}
      icon={UserCog}
      accentColor="blue"
    >
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-6">
          <TabsTrigger value="categories" className="flex items-center gap-2">
            <Icon name="Tags" size={16} />
            {t('settings.roleCategories.tab')}
          </TabsTrigger>
          <TabsTrigger value="review-settings" className="flex items-center gap-2">
            <Icon name="CalendarClock" size={16} />
            {t('settings.roleReview.tab')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="categories">
          <CategoriesTab />
        </TabsContent>
        <TabsContent value="review-settings">
          <ReviewSettingsTab />
        </TabsContent>
      </Tabs>
    </PageLayout>
  );
};

export default TeamRoleManagementSettings;
